import CloseIcon from './component.jsx'
export default CloseIcon
